<script setup lang="ts">
import CanvasButton from "@/components/canvas/CanvasButton.vue";
import DraggerMenuState from "@/stores/DraggerMenuState";

function toggle() {
  DraggerMenuState.setAdditiveSelection(!DraggerMenuState.additiveSelection);
}
</script>
<template>
  <CanvasButton
    @click.prevent.stop="toggle"
    phosphor-icon="selection-plus"
    :tooltipTitle="$t('canvas:tools.options.additiveSelection.tooltip.title')"
    :tooltipText="$t('canvas:tools.options.additiveSelection.tooltip.text')"
    :mode="DraggerMenuState.additiveSelection"
  />
</template>
